<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Empresas</h2>
          <!--p class="text-purple-manax pl-3">Listado de Empresas</p-->
        </span>
        <span class="pull-right pt-1 pb-4 pr-3">
          <button mat-raised-button type="button" class="btn btn-manax p-2 mr-1" (click)="openNewCompanyModal()">
            <i class="material-icons">add</i> Nuevo
          </button>
          <button mat-raised-button type="button" class="btn btn-outline-manax p-2" (click)="openCompaniesStats()">
            <i class="material-icons">query_stats</i> Estadísticas de Uso
          </button>
        </span>
        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortCompanies($event)" stickyHeader
          stickyFooter>

          <thead class="text-purple-manax">
            <tr>

              <!-- All -->
              <th class="p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell" mat-sort-header="name">
                Nombre
              </th>
              <th class="d-none d-md-table-cell">
                Logo
              </th>
              <th class="d-none d-md-table-cell" mat-sort-header="country">
                País
              </th>
              <th class="d-none d-md-table-cell" mat-sort-header="currency">
                Moneda
              </th>
              <th class="d-none d-md-table-cell" mat-sort-header="address">
                Dirección
              </th>
              <th class="d-none d-md-table-cell" mat-sort-header="email">
                Email
              </th>
              <th class="d-none d-md-table-cell" mat-sort-header="phone">
                Teléfono
              </th>
              <th class="d-none d-md-table-cell" mat-sort-header="taxId" style="white-space: nowrap;">
                Nro. Id. Fiscal
              </th>

              <!-- Mobile -->
              <th class="d-table-cell d-md-none">
                Orden por: <span class="ml-2">{{sortOptions[filter.sort || ''] || 'ninguno'}}</span>
                <span class="text-purple-manax pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th>

              <!-- All -->
              <th class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                    <span>Filtros</span>
                  </button>
                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortCompanies(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortCompanies('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let company of companies" [class.text-danger]="company.isDeleted" class='cursor-pointer'
              (click)="openCompanyModal(company, true)">

              <!-- All -->
              <td class="p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(company._id)"
                      [checked]="selection.all || selection[company._id || '']">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell">
                {{company.name}}
              </td>
              <td class="d-none d-md-table-cell">
                <ng-container *ngIf="company.logo?.fileUrl">
                  <img class="image-preview cursor-pointer pt-3" [src]="company.logo.fileUrl" />
                </ng-container>
              </td>
              <td class="d-none d-md-table-cell">{{company.country?.name}}</td>
              <td class="d-none d-md-table-cell">
                {{company.country?.currency?.name}}
                <span *ngIf="company.country?.currency?.symbol">({{company.country?.currency?.symbol}})</span>
              </td>
              <td class="d-none d-md-table-cell">{{company.address}}</td>
              <td class="d-none d-md-table-cell">{{company.email}}</td>
              <td class="d-none d-md-table-cell">{{company.phone}}</td>
              <td class="d-none d-md-table-cell">{{company.taxId}}</td>
              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <b>{{company.name}}</b><br>
                <ng-container *ngIf="company.logo?.fileUrl">
                  <img class="image-preview cursor-pointer pt-3" [src]="company.logo.fileUrl" />
                </ng-container>
                {{company.country?.name}}<br>
                {{company.country?.currency?.code}}
                <span *ngIf="company.country?.currency?.symbol">({{company.country?.currency?.symbol}})</span><br>
                {{company.address}}<br>{{company.email}}<br>{{company.phone}}<br>Nro. Id. Fiscal:
                {{company.taxId}}
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openCompanyModal(company, true)">
                    <span>Abrir</span>
                  </button>
                  <button mat-menu-item (click)="openCompanyModal(company)">
                    <span>Modificar</span>
                  </button>
                  <button mat-menu-item (click)="openSubscriptionModal(company)">
                    <span>Suscripcion</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteCompanyConfirm(company, true)" *ngIf="isDev">
                    <span>Hard Delete</span>
                  </button>
                  <button mat-menu-item (click)="openDeleteCompanyConfirm(company)" *ngIf="!company.isDeleted">
                    <span>Eliminar</span>
                  </button>
                  <button mat-menu-item (click)="openRestoreCompanyConfirm(company)" *ngIf="company.isDeleted">
                    <span>Restaurar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center" >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ companies.length }} empresas</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</div>